var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import "./Reminders.css";
import { useTranslation } from "react-i18next";
import RemindersInvitee from "./remindersInvitee";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd, faClose } from "@fortawesome/pro-solid-svg-icons";
import { useGetRemindersInviteesQuery } from "@/store/api";
export default function RemindersBlock(_a) {
    var reminder = _a.reminder, index = _a.index, timeOptions = _a.timeOptions, remindersInvitees = _a.remindersInvitees, remindersData = _a.remindersData, setRemindersData = _a.setRemindersData, defaultInvitee = _a.defaultInvitee, appStrings = _a.appStrings, module = _a.module, record = _a.record;
    var _b = useState(false), checkedPopup = _b[0], setCheckedPopup = _b[1];
    var _c = useState(false), checkedEmail = _c[0], setCheckedEmail = _c[1];
    var _d = useState(true), skipAllInvitee = _d[0], setSkipAllInvitee = _d[1];
    var _e = useState(remindersInvitees), allRemindersInvites = _e[0], setAllRemindersInvites = _e[1];
    var _f = useState([]), hasError = _f[0], setError = _f[1];
    var _g = useState(reminder), reminderC = _g[0], setReminderC = _g[1];
    var t = useTranslation(["Meetings", "Calls", "common"]).t;
    var convertNumberToBoolean = function (value) {
        var ret = false;
        if (value === 1 || value === "1") {
            ret = true;
        }
        return ret;
    };
    var convertBooleanToNumber = function (value) {
        var ret = 0;
        if (value === true) {
            ret = 1;
        }
        return ret;
    };
    var updateError = function (msg) {
        setError(__spreadArray(__spreadArray([], hasError, true), [msg], false));
    };
    var updateRemindersErrors = function (valueToTest, valueToCompare) {
        if (valueToTest === false) {
            valueToCompare === 0 || valueToCompare === "0"
                ? setError(__spreadArray(__spreadArray([], hasError, true), [
                    appStrings["ERR_REMINDER_IS_NOT_SET_POPUP_OR_EMAIL"],
                ], false))
                : setError(hasError.filter(function (e) {
                    return e !== appStrings["ERR_REMINDER_IS_NOT_SET_POPUP_OR_EMAIL"];
                }));
        }
        else {
            setError(hasError.filter(function (e) {
                return e !== appStrings["ERR_REMINDER_IS_NOT_SET_POPUP_OR_EMAIL"];
            }));
        }
    };
    // Reminder checbox Popup
    var updatePopup = function (reminder, index, e) {
        updateRemindersErrors(checkedPopup, reminder.email);
        setCheckedPopup(!checkedPopup);
        var temp = __assign(__assign({}, reminder), { popup: convertBooleanToNumber(checkedPopup) });
        var newReminders = remindersData.map(function (item, i) {
            return i === index ? temp : item;
        });
        setRemindersData(newReminders);
    };
    // Reminder checbox Email
    var updateEmail = function (reminder, index, e) {
        updateRemindersErrors(checkedEmail, reminder.popup);
        setCheckedEmail(!checkedEmail);
        var temp = __assign(__assign({}, reminder), { email: convertBooleanToNumber(checkedEmail) });
        var newReminders = remindersData.map(function (item, i) {
            return index === i ? temp : item;
        });
        setRemindersData(newReminders);
    };
    var removeReminder = function (ind) {
        var newReminders = remindersData.filter(function (item, i) {
            return i !== ind;
        });
        setRemindersData(newReminders);
    };
    var setRemindersInviteesData = function (value) {
        setRemindersData(value);
    };
    var removeReminderFromInvitation = function (value) {
        removeReminder(index);
    };
    var setRemindersInvitees = function (newInvitee) {
        var temp = __assign(__assign({}, reminder), { invitees: newInvitee });
        var newReminders = remindersData.map(function (item, i) {
            return i === index ? temp : item;
        });
        setRemindersData(newReminders);
    };
    // Gestion erreur
    useEffect(function () {
        hasError.length > 0
            ? setReminderC(__assign(__assign({}, reminder), { isValid: false }))
            : setReminderC(__assign(__assign({}, reminder), { isValid: true }));
    }, [hasError]);
    useEffect(function () {
        var newReminders = remindersData.map(function (item, i) {
            return i === index && reminderC ? reminderC : item;
        });
        setRemindersData(newReminders);
    }, [reminderC]);
    // All invitees
    var recordId = (record === null || record === void 0 ? void 0 : record.id) || "";
    var allInvitesResponse = useGetRemindersInviteesQuery({
        moduleName: module || "Meetings",
        recordId: recordId,
    }, { skip: skipAllInvitee }).data;
    useEffect(function () {
        if (allInvitesResponse === null || allInvitesResponse === void 0 ? void 0 : allInvitesResponse.data) {
            setRemindersInvitees(allInvitesResponse === null || allInvitesResponse === void 0 ? void 0 : allInvitesResponse.data);
            setAllRemindersInvites(allInvitesResponse === null || allInvitesResponse === void 0 ? void 0 : allInvitesResponse.data);
        }
    }, [allInvitesResponse]);
    return (_jsxs("li", __assign({ className: "reminder_item", style: {
            border: "".concat(hasError.length > 0 ? "1px solid red" : "1px solid lightgray"),
        } }, { children: [_jsx("ul", { children: hasError.length > 0 &&
                    hasError.map(function (error) { return (_jsx("li", __assign({ className: "text-red-500" }, { children: error }))); }) }), _jsx("div", { className: "clear" }), _jsxs("div", __assign({ className: "col" }, { children: [_jsx("span", { children: t("LBL_REMINDERS_ACTIONS") }), "\u00A0"] })), _jsx("div", { className: "clear" }), _jsxs("div", __assign({ className: "col" }, { children: [_jsx("input", { type: "checkbox", className: "popup_chkbox", checked: convertNumberToBoolean(reminder.popup), onChange: function (e) {
                            updatePopup(reminder, index, e);
                        } }), _jsx("span", { children: t("LBL_REMINDERS_POPUP") }), "\u00A0", _jsx("span", { className: "reminder_when_value" }), _jsx("br", {}), _jsx("select", __assign({ className: "timer_sel_popup", value: reminder.timer_popup, onChange: function (e) {
                            var temp = __assign(__assign({}, reminder), { timer_popup: e.target.value });
                            var newReminders = remindersData.map(function (item, i) {
                                return i === index ? temp : item;
                            });
                            setRemindersData(newReminders);
                        } }, { children: timeOptions &&
                            Object.entries(timeOptions).map(function (item) { return (_jsx("option", __assign({ label: item[1], value: item[0] }, { children: item[1] }))); }) }))] })), _jsxs("div", __assign({ className: "col" }, { children: [_jsx("input", { type: "checkbox", className: "email_chkbox", checked: convertNumberToBoolean(reminder.email), onChange: function (e) {
                            updateEmail(reminder, index, e);
                        } }), _jsx("span", { children: t("LBL_REMINDERS_EMAIL") }), "\u00A0", _jsx("span", { className: "reminder_when_value" }), _jsx("br", {}), _jsx("select", __assign({ className: "timer_sel_email", value: reminder.timer_email, onChange: function (e) {
                            var temp = __assign(__assign({}, reminder), { timer_email: e.target.value });
                            var newReminders = remindersData.map(function (item, i) {
                                return i === index ? temp : item;
                            });
                            setRemindersData(newReminders);
                        } }, { children: timeOptions &&
                            Object.entries(timeOptions).map(function (item) { return (_jsx("option", __assign({ label: item[1], value: item[0] }, { children: item[1] }))); }) }))] })), _jsx("div", { className: "clear" }), _jsx("div", __assign({ className: "col" }, { children: remindersInvitees.length > 0 && (_jsx("ul", __assign({ className: "invitees_list " }, { children: remindersInvitees.map(function (invitee, ind) { return (_jsx(RemindersInvitee, { invitee: invitee, remindersData: remindersData, setRemindersData: setRemindersInviteesData, removeReminder: removeReminderFromInvitation, reminder: reminder, index: ind, updateErrorMsg: updateError, appStrings: appStrings })); }) }))) })), _jsx("div", { className: "clear" }), _jsxs("div", __assign({ className: "btns" }, { children: [_jsxs("button", __assign({ className: "button success etc-all-invitees", type: "button", onClick: function (e) {
                            setSkipAllInvitee(false);
                            setRemindersInvitees(allRemindersInvites);
                            setError(hasError.filter(function (e) {
                                return e !== appStrings["ERR_NO_INVITEES_FOR_REMINDER"];
                            }));
                        } }, { children: [_jsx("span", __assign({ className: "suitepicon suitepicon-action-plus" }, { children: _jsx(FontAwesomeIcon, { icon: faAdd, className: "pr-2 cursor-pointer text-white" }) })), t("LBL_REMINDERS_ADD_ALL_INVITEES")] })), _jsxs("button", __assign({ className: "button danger mt-[2px] ml-[10px]", type: "button", onClick: function (e) { return removeReminder(index); } }, { children: [_jsx("span", { className: "suitepicon suitepicon-action-minus" }), t("LBL_REMINDERS_REMOVE_REMINDER"), _jsx(FontAwesomeIcon, { icon: faClose, className: "ml-2 cursor-pointer text-white" })] }))] })), _jsx("div", { className: "clear" })] }), index));
}
